export class UnexpectedError extends Error {
  constructor() {
    super("Unexpected");
  }
}
